__webpack_require__.p = "/inkapi/";